import { IoClose } from "react-icons/io5";
import css from "./TariffExpiredWarningModal.module.css";
import ModalCloseIcon from "../../sharedComponents/ModalCloseIcon/ModalCloseIcon";

// Попередження про вихід із системи, якщо тариф не продовжено
export default function TariffExpiredWarningModal({
  remainingDaysTillDelete,
  onContinue,
  onClose,
}) {
  return (
    <div
      className={css.modal}
      role="alertdialog"
      aria-labelledby="tariff-expired-title"
    >
      <ModalCloseIcon onClose={onClose} />

      <span className={css.iconWrap}>
        <IoClose className={css.icon} />
      </span>

      <h2 id="tariff-expired-title" className={css.title}>
        Термін дії вашого тарифного плану закінчився
      </h2>
      <p className={css.description}>
        Будь ласка, продовжіть тариф. В іншому випадку Вас буде перенаправлено
        на сторінку входу після закриття цього повідомлення.
      </p>
      {remainingDaysTillDelete > 0 && (
        <p className={css.note}>
          Якщо ви не продовжите тариф, ваш акаунт буде видалено через{" "}
          {remainingDaysTillDelete} днів.
        </p>
      )}

      <div className={css.buttons}>
        <button type="button" className={css.cancelBtn} onClick={onClose}>
          Скасувати
        </button>
        <button type="button" className={css.continueBtn} onClick={onContinue}>
          Продовжити тариф
        </button>
      </div>
    </div>
  );
}
